import React, { useEffect, useState } from "react";
import style from "./topNav.module.css";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import GoogleTranslate from "../googleTranslate/GoogleTranslate";
import { useDashBoardData } from "../../context/dashboardDataContext/DashboardDataContext";

const TopNavbar = () => {
  const {
    increaseFontSize,
    resetFontSize,
    decreaseFontSize,
    contactInfo,
    socialLinks,
  } = useDashBoardData();
  const [isSticky, setSticky] = useState(false);
  // const [skipToHide, setSkipToHide] = useState(true);
  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setSticky(offset > 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleSkipToHide = () => {
    // setSkipToHide(false);
    window.scrollTo({ behavior: "smooth", top: "180" });
  };

  return (
    <div
      className={
        isSticky
          ? `${style.top_navbar_main} sticky`
          : `${style.top_navbar_main}`
      }
    >
      <div className={`${style.top_left_sec}`}>
        <span className={`${style.top_left_sec_title}`}>भारत सरकार</span>
      </div>
      <div className={`${style.top_right_sec}`}>
        <ul className={`${style.top_right_sec_ul}`}>
          {/* <li className={`${style.t_r_s_ul_li}`}>
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
              >
                <mask
                  id="mask0_59_4029"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="28"
                  height="28"
                >
                  <rect width="28" height="28" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_59_4029)">
                  <path
                    d="M22.7994 23.6452L15.4718 16.1783C14.8885 16.669 14.2176 17.0531 13.4593 17.3305C12.701 17.6079 11.9164 17.7466 11.1058 17.7466C9.11174 17.7466 7.42414 17.0431 6.04296 15.636C4.66178 14.2289 3.97119 12.5097 3.97119 10.4782C3.97119 8.44681 4.66161 6.72693 6.04243 5.31859C7.42326 3.91027 9.11044 3.20612 11.104 3.20612C13.0975 3.20612 14.7852 3.90984 16.1673 5.31728C17.5493 6.72473 18.2404 8.44442 18.2404 10.4764C18.2404 11.3253 18.1005 12.1362 17.8208 12.9089C17.5411 13.6817 17.1679 14.3539 16.7012 14.9254L24.0288 22.3923L22.7994 23.6452ZM11.1058 15.9634C12.609 15.9634 13.8822 15.4319 14.9255 14.3687C15.9688 13.3056 16.4904 12.0082 16.4904 10.4764C16.4904 8.94457 15.9688 7.64712 14.9255 6.58401C13.8822 5.52089 12.609 4.98934 11.1058 4.98934C9.60256 4.98934 8.32931 5.52089 7.28604 6.58401C6.24279 7.64712 5.72116 8.94457 5.72116 10.4764C5.72116 12.0082 6.24279 13.3056 7.28604 14.3687C8.32931 15.4319 9.60256 15.9634 11.1058 15.9634Z"
                    fill="white"
                  />
                </g>
              </svg>
            </span>
          </li> */}
          {/* <li className={`${style.t_r_s_ul_li}`}>
            <span>
              <img
                src={require("../../assets/images/icons/nav-icon-1.png")}
                alt="nav-img"
                className={`img-fluid ${style.top_nav_c_icon}`}
                width={20}
              />
            </span>
          </li> */}
          <li className={`${style.t_r_s_ul_li_mobile}`}>
            <Link
              to={`tel:${contactInfo?.contact_us?.mobile}`}
              className={`${style.t_nav_contact_btn}`}
            >
              Contact
            </Link>
          </li>
          <li
            className={`${style.t_r_s_ul_li} ${style.t_r_s_ul_li_mobile_hide} ${style.social_links_h}`}
            style={{ position: "relative" }}
          >
            <span>Social Links</span>
            <div className={`${style.header_social_links_box}`}>
              <ul className={`${style.header_social_links_ul}`}>
                <li>
                  <Link
                    // to="https://www.facebook.com/MicrodynamicSoftware/"
                    to={`${socialLinks?.facebook}`}
                    target="_blank"
                    className={`${style.footer_social_icons_links}`}
                  >
                    <FaFacebook />
                  </Link>
                </li>
                <li className={`${style.footer_social_icons_list}`}>
                  <Link
                    to={`${socialLinks?.instagram}`}
                    target="_blank"
                    className={`${style.footer_social_icons_links}`}
                  >
                    <FaInstagram />
                  </Link>
                </li>
                <li className={`${style.footer_social_icons_list}`}>
                  <Link
                    to={`${socialLinks?.linkedin}`}
                    target="_blank"
                    className={`${style.footer_social_icons_links}`}
                  >
                    <FaLinkedinIn />
                  </Link>
                </li>
                <li className={`${style.footer_social_icons_list}`}>
                  <Link
                    to={`${socialLinks?.youtube}`}
                    target="_blank"
                    className={`${style.footer_social_icons_links}`}
                  >
                    <FaYoutube />
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          <li
            className={`${style.t_r_s_ul_li} ${style.t_r_s_ul_li_mobile_hide}`}
            onClick={handleSkipToHide}
            style={{ cursor: "pointer" }}
          >
            <span>Skip To Main Content</span>
          </li>
          {/* <li
            className={`${style.t_r_s_ul_li} ${style.t_r_s_ul_li_mobile_hide}`}
          >
            <div className="d-flex">
              <button onClick={increaseFontSize}>Increase Font Size</button>
              <button onClick={resetFontSize}>Reset Font Size</button>
              <button onClick={decreaseFontSize}>Decrease Font Size</button>
            </div>
          </li> */}
          <li
            style={{ borderLeft: "1px solid #fff", overflow: "hidden" }}
            className={`${style.t_r_s_ul_li_mobile_hide}`}
          >
            {/* <span>English</span> */}
            <GoogleTranslate />
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TopNavbar;
